import React, { useState, useEffect } from 'react';
import axios from 'axios';

const MobileVersionsTab = ({ token }) => {
  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ platform: 'android', version: '', build_number: '', is_required: false, release_notes: '', download_url: '' });

  const headers = { Authorization: `Bearer ${token}` };

  const fetchVersions = async () => {
    try {
      const res = await axios.get('/api/admin/mobile-versions', { headers });
      setVersions(res.data.data || []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchVersions(); }, [token]);

  const openEdit = (v) => {
    setEditing(v.id);
    setForm({ platform: v.platform, version: v.version, build_number: v.build_number, is_required: !!v.is_required, release_notes: v.release_notes || '', download_url: v.download_url || '' });
    setShowModal(true);
  };

  const save = async () => {
    try {
      if (editing) {
        await axios.put(`/api/admin/mobile-versions/${editing}`, form, { headers });
      } else {
        await axios.post('/api/admin/mobile-versions', form, { headers });
      }
      setShowModal(false);
      setEditing(null);
      setForm({ platform: 'android', version: '', build_number: '', is_required: false, release_notes: '', download_url: '' });
      fetchVersions();
    } catch (e) { alert('Hata: ' + (e.response?.data?.error?.message || e.message)); }
  };

  const deleteVersion = async (id) => {
    if (!window.confirm('Bu sürümü silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`/api/admin/mobile-versions/${id}`, { headers });
      fetchVersions();
    } catch (e) { console.error(e); }
  };

  if (loading) return <div className="empty">Yükleniyor...</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h3 style={{ margin: 0, color: '#FFFFFF', fontSize: '18px' }}>📱 Mobil Uygulama Sürümleri</h3>
        <button className="btn-approve" onClick={() => { setEditing(null); setForm({ platform: 'android', version: '', build_number: '', is_required: false, release_notes: '', download_url: '' }); setShowModal(true); }}>
          + Yeni Sürüm
        </button>
      </div>

      {versions.length === 0 ? (
        <div className="empty">Henüz sürüm eklenmemiş</div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
          <thead>
            <tr style={{ color: '#6B7280', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
              <th style={{ padding: '10px 12px', textAlign: 'left' }}>Platform</th>
              <th style={{ padding: '10px 12px', textAlign: 'left' }}>Sürüm</th>
              <th style={{ padding: '10px 12px', textAlign: 'right' }}>Build</th>
              <th style={{ padding: '10px 12px', textAlign: 'center' }}>Zorunlu</th>
              <th style={{ padding: '10px 12px', textAlign: 'right' }}>Tarih</th>
              <th style={{ padding: '10px 12px', textAlign: 'right' }}>İşlem</th>
            </tr>
          </thead>
          <tbody>
            {versions.map(v => (
              <tr key={v.id} style={{ borderBottom: '1px solid rgba(255,255,255,0.03)' }}>
                <td style={{ padding: '10px 12px', color: '#E5E7EB' }}>
                  <span style={{ marginRight: '6px' }}>{v.platform === 'android' ? '🤖' : '🍎'}</span>
                  {v.platform === 'android' ? 'Android' : 'iOS'}
                </td>
                <td style={{ padding: '10px 12px', color: '#60A5FA', fontWeight: '600' }}>{v.version}</td>
                <td style={{ padding: '10px 12px', textAlign: 'right', color: '#9CA3AF' }}>{v.build_number}</td>
                <td style={{ padding: '10px 12px', textAlign: 'center' }}>
                  {v.is_required ? <span style={{ color: '#FCA5A5' }}>⚠️ Evet</span> : <span style={{ color: '#6B7280' }}>Hayır</span>}
                </td>
                <td style={{ padding: '10px 12px', textAlign: 'right', color: '#9CA3AF' }}>
                  {new Date(v.created_at).toLocaleDateString('tr-TR')}
                </td>
                <td style={{ padding: '10px 12px', textAlign: 'right' }}>
                  <button className="btn-edit" style={{ marginRight: '4px' }} onClick={() => openEdit(v)}>Düzenle</button>
                  <button className="btn-delete" onClick={() => deleteVersion(v.id)}>Sil</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ width: '480px' }}>
            <h3>{editing ? '✏️ Sürüm Düzenle' : '📱 Yeni Sürüm'}</h3>
            <div className="form-group">
              <label>Platform</label>
              <select value={form.platform} onChange={e => setForm({ ...form, platform: e.target.value })}>
                <option value="android">Android</option>
                <option value="ios">iOS</option>
              </select>
            </div>
            <div className="form-group">
              <label>Versiyon</label>
              <input value={form.version} onChange={e => setForm({ ...form, version: e.target.value })} placeholder="1.0.0" />
            </div>
            <div className="form-group">
              <label>Build Numarası</label>
              <input type="number" value={form.build_number} onChange={e => setForm({ ...form, build_number: parseInt(e.target.value) })} />
            </div>
            <div className="form-group">
              <label>
                <input type="checkbox" checked={form.is_required} onChange={e => setForm({ ...form, is_required: e.target.checked })} style={{ marginRight: '8px', accentColor: '#3B82F6' }} />
                Zorunlu Güncelleme
              </label>
            </div>
            <div className="form-group">
              <label>Sürüm Notları</label>
              <textarea value={form.release_notes} onChange={e => setForm({ ...form, release_notes: e.target.value })} rows={3} placeholder="Yenilikler..." />
            </div>
            <div className="form-group">
              <label>İndirme Linki</label>
              <input value={form.download_url} onChange={e => setForm({ ...form, download_url: e.target.value })} placeholder="https://play.google.com/..." />
            </div>
            <div className="modal-actions" style={{ marginTop: '20px' }}>
              <button className="btn-cancel" onClick={() => setShowModal(false)}>İptal</button>
              <button className="btn-approve" onClick={save} disabled={!form.version || !form.build_number}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileVersionsTab;
